export class ProjectView {
    constructor(public name: string, public code: string, public status: string) {}
}
